import styled from '@emotion/styled'

export const Wrapper = styled('div')({
  position: 'relative',
  height: '100%',
  width: '100%',
})

export const SearchBoxContainer = styled('div')({
  position: 'absolute',
  top: '10px',
  left: '10px',
  right: '10px',
  zIndex: 5,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

export const MapTypeToggle = styled('div')({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#FFFFFF',
  borderRadius: '4px',
  boxShadow: 'rgba(0, 0, 0, 0.25) 0px 2px 6px -1px',
  padding: '2px',
  height: '38px',
  boxSizing: 'border-box',
})

export const SearchInput = styled('input')({
  borderRadius: '4px',
  border: 'none',
  boxShadow: 'rgba(0, 0, 0, 0.25) 0px 2px 6px -1px',
  fontFamily: 'Roboto, Arial, sans-serif',
  fontSize: '14px',
  padding: '9px 12px',
  width: '100%',
  outline: 'none',
  height: '38px',
  boxSizing: 'border-box',
  backgroundColor: '#FFFFFF',
})

export const SearchInputWrapper = styled('div')({
  flex: 1,
  minWidth: 0,
})

export const DrawingToolbar = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: '#FFFFFF',
  borderRadius: '4px',
  boxShadow: 'rgba(0, 0, 0, 0.25) 0px 2px 6px -1px',
  padding: '4px',
  height: '38px',
  boxSizing: 'border-box',
})
